<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 発注書出力ボタン -->
      <div v-if="false" :style="{ height: basicHeight + 'px' }">
        <t-row>
          <t-col :span="24" class="right">
            <t-button
              round
              type="primary"
              class="dialogButton_150_40"
              ref="orderNoteOutputBtn"
              :disabled="areAllSelectedValuesOne"
              @click="orderNoteOutputClick()"
            >
              <i class="el-icon-download"></i
              >{{ $t("resource.ORDER.ORDER_EXCEL_OUTPUT") }}
            </t-button>
          </t-col>
        </t-row>
      </div>

      <!-- 再入荷テーブル -->
      <div>
        <t-table
          ref="restockTable"
          :data="restockTable"
          header-cell-class-name="bg-default"
          class="table_common"
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          border
        >
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <template slot-scope="scope">
              <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
              <!-- <t-input
                v-if="
                  column.prop === 'odRemarks' &&
                  scope.row['odPayStatus'] === '1'
                "
                class="cell_input"
                :controls="false"
                maxLength="200"
                width="100%"
                v-model="scope.row[column.prop]"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              ></t-input> -->

              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_備考機能の追加 -->
              <!-- <t-input
                v-if="
                  column.prop === 'odRemarks' &&
                  scope.row['odPayStatus'] === '1'
                "
                class="cell_input"
                :controls="false"
                maxLength="200"
                width="100%"
                v-model="scope.row[column.prop]"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
                @focus="selectValue($event)"
              ></t-input> -->
              <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
              <t-input
                v-if="
                  column.prop === 'odSupplementAmount' &&
                  scope.row['odPayStatus'] === '1' &&
                  supplementAmountAbleCheck(scope.row)
                "
                class="cell_input_custom"
                :controls="false"
                maxLength="10"
                width="100%"
                v-model="scope.row[column.prop]"
                @blur="changeCellData(scope.row, column.prop)"
                @focus="changeCellDataToNumber(scope.row, column.prop)"
                @input="
                  scope.row[column.prop] = scope.row[column.prop].replace(
                    /[^\d]/g,
                    ''
                  )
                "
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              ></t-input>

              <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
              <!-- 支払区分  -->
              <!-- <t-select
                v-else-if="column.prop === 'odExPayMethod'"
                v-model="scope.row[column.prop]"
                @change="clearNoteOutCheckBox(scope.row)"
                :disabled="scope.row.odPayStatus !== '1'"
                placeholder=""
              >
                <t-option
                  v-for="item in getPayMethodList(scope.row)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </t-option>
              </t-select> -->
              <!--DEL 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
              <!-- 注文書出力  -->
              <t-checkbox
                v-else-if="
                  column.prop === 'odOrderNoteOut' ||
                  column.prop === 'odCloseState'
                "
                v-model="scope.row[`${column.prop}Bool`]"
                @change="handleCheckboxChange(scope.row, scope.column)"
                :disabled="editCellData(scope.row, scope.column)"
              >
              </t-checkbox>
              <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->

              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
              <!-- 品質保証部の権限を追加する -->
              <!-- <t-date-picker
                v-else-if="
                  dueDateInputProc(scope.row, column)
                "
                v-model="scope.row[column.prop]"
                class="dialogDate"
                :clearable="false"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                :editable="false"
                :show-icon="false"
              >
              </t-date-picker> -->
              <t-date-picker
                v-else-if="
                  dueDateInputProc(scope.row, column) && !isDLUserLocal
                "
                v-model="scope.row[column.prop]"
                class="dialogDate"
                :clearable="false"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                :editable="false"
                :show-icon="false"
              >
              </t-date-picker>
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
              <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              <span v-else>
                {{ scope.row[column.prop] }}
              </span>
            </template>
          </t-table-column>

          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
          <!-- 課題_備考機能の追加 -->
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
          <!-- 共通備考の調整 -->
          <!-- <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            class="cell_txt_center"
            :min-width="100"
          >
            <template slot-scope="scope">
              <div class="button-container">
                <t-tooltip placement="bottom" effect="light">
                  <div
                    slot="content"
                    class="tooltip-content"
                    v-html="formatRemarksShowProc(scope.row.aodProdRemarksSum)"
                  ></div>
                  <t-button
                    :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                    icon="el-icon-search"
                    size="small"
                    circle
                  >
                  </t-button>
                </t-tooltip>
                <t-button
                  type="warning"
                  icon="el-icon-edit"
                  size="small"
                  circle
                  @click="addRemarksProd(scope.row, $event)"
                ></t-button>
              </div>
            </template>
          </t-table-column> -->
          <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            prop="aodProdRemarksSum"
            :class-name="'cell_txt_center'"
            :width="getRemarksColumnWidthProc()"
          >
            <template slot-scope="scope">
              <div class="bikouDiv">
                <!-- 備考表示 -->
                <span class="bikouText">
                  {{ scope.row.aodProdRemarksSum }}
                </span>

                <!-- 品質保証部の権限を追加する -->
                <t-button
                  type="warning"
                  icon="el-icon-edit"
                  size="small"
                  class="bikouButton"
                  circle
                  @click="showRemarksDialogProc(scope.row, $event)"
                  :disabled="isDLUserLocal"
                ></t-button>
              </div>
            </template>
          </t-table-column>
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
        </t-table>
      </div>

      <!-- 確定ボタン-->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="24" class="right">
            <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
            <!-- 品質保証部の権限を追加する -->
            <!-- <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="confirmClick()"
              :disabled="restockTable.length == 0"
            > -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="confirmClick()"
              :disabled="restockTable.length == 0 || isDLUserLocal"
            >
              <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->

              <i class="el-icon-check"></i>{{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { ShowOrderExcelOutputDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  outputExcelToZip,
  showRemarksDialog,
  showRemarksUpdDialog,
} from "@/services/common";
import {
  getInitInfoListForRestock,
  searchRestockInfoByObOrderNo,
  updateRestockInfoByObOrderNo,
} from "@/services/order";
import {
  cmpDetailData,
  formatCurrencyToNumber,
  formatDateStrToString,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NUM_TWO,
  PROD_EX_JP_RCV,
  PROD_EX_SEND,
  STR_EMPTY,
  STR_ONE,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0, //  DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        10
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      orderNoteOutputBtnFlg: true,

      //再入荷テーブル
      restockTable: [],

      //再入荷テーブルの列
      columns: [
        {
          prop: "odProdExKbn",
          label: t("resource.ORDER.PRODUCT_EX_KBN"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },
        {
          prop: "odExCreateDate",
          label: t("resource.ORDER.EX_CREATE_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },
        {
          prop: "odExReceSendNo",
          label: t("resource.ORDER.EX_RECE_SEND_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 仕入先納期
        {
          prop: "odDueDate",
          label: t("resource.ORDER.OD_DUE_DATE"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_center",
        },
        // 仕入先納期履歴
        {
          prop: "odDueDateHistory",
          label: t("resource.ORDER.OD_DUE_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        {
          prop: "odProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
          overflowTooltip: true,
        },
        {
          prop: "odProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
          overflowTooltip: true,
        },
        {
          prop: "odProdExQty",
          label: t("resource.ORDER.PROD_EX_QTY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        // {
        //   prop: "aodCloseState",
        //   label: t("resource.ORDER.ACCEPT_ORDER_CLOSE_STATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   align: "center",
        // },
        {
          prop: "odCloseState",
          label: t("resource.ORDER.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "center",
        },
        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // {
        //   prop: "odExPayMethod",
        //   label: t("resource.ORDER.EX_PAY_METHOD"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_THIRTY"),
        //   align: "center",
        // },

        // 補足金額
        // {
        //   prop: "odSupplementAmount",
        //   label: t("resource.ORDER.SUPPLEMENT_AMOUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   align: "right",
        // },
        // DEL 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        // {
        //   prop: "odOrderNoteOut",
        //   label: t("resource.ORDER.ORDER_NOTE_OUT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   align: "center",
        // },
        {
          prop: "odReceCompleteQty",
          label: t("resource.JP_RECEIVE.RECE_COMPLETE_QUANTITY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // {
        //   prop: "odRemarks",
        //   label: t("resource.COMMON_CONSTANT.BIKOU"),
        //   width: t("widgetSize.COMMON_WIDTH.TWO_HUNDRED"),
        //   align: "left",
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      data: null,

      showFlag: false,

      //true:先に更新して、後で出力する; false:更新のみ
      outputFlg: false,

      //クローズ状態リスト
      closeStateList: [],

      //支払状態リスト  1：不要  2：必要
      exPayMethodList: [],
      //支払状態リスト(補足) 1：補足不要  2：補足必要
      supplementPayMethodList: [],
      //支払状態リスト(赤点)  1：赤点不要  2：赤点必要
      redPayMethodList: [],

      //製品異常区分リスト
      prodExKbnList: [],

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // 品質保証部の権限を追加する
      isDLUserLocal: false,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },
  props: {
    obOrderNo: {
      Type: String,
      default: STR_EMPTY,
    },
    obOrderNoShow: {
      Type: String,
      default: STR_EMPTY,
    },
    isAdd: {
      Type: Boolean,
      default: false,
    },
    SupCurrency: {
      Type: Object,
    },

    FactoryKbn: {
      Type: Object,
    },
  },
  mounted() {
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 品質保証部の権限を追加する
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  computed: {
    areAllSelectedValuesOne() {
      return this.restockTable.every((row) => row.odExPayMethod === "1");
    },
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;

      //基本情報のリスト取得（異常区分、受注クローズ、支払区分）
      getInitInfoListForRestock()
        .then((res) => {
          //クローズ状態リストの取得
          this.closeStateList = res.closeStateList;

          //支払状態リストの取得
          // this.exPayMethodList = res.exPayMethodList;
          // 支払状態リスト  1：不要  2：必要
          res.exPayMethodList.forEach((item) => {
            let newItem = {
              value: item.DomainKbnVal,
              label: item.DomainKbnName,
            };

            let supplementNewItem = {
              value: item.DomainKbnVal,
              label: item.Description1,
            };

            let redNewItem = {
              value: item.DomainKbnVal,
              label: item.Description2,
            };
            //支払状態リストに追加
            this.exPayMethodList.push(newItem);
            //支払状態リスト(補足)に追加
            this.supplementPayMethodList.push(supplementNewItem);
            //支払状態リスト(赤点)に追加
            this.redPayMethodList.push(redNewItem);
          });

          //異常区分リストの取得
          this.prodExKbnList = res.prodExKbnList;

          //明細情報の検索
          this.searchRestockInfoByObOrderNoProc();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          //確定ボタンが使用不可に変更
          this.btnConfirmFlg = true;
        });
    },

    //検索
    searchRestockInfoByObOrderNoProc() {
      //再入荷情報の検索
      searchRestockInfoByObOrderNo({
        odOrderNo: this.obOrderNo,
        odOrderNoShow: this.obOrderNoShow,
      })
        .then((res) => {
          //再入荷テーブル
          this.restockTable = res;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (res != null && res.length != 0) {
            this.aodUpdateTime = res[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          if (this.restockTable.length > 0) {
            this.orderNoteOutputBtnFlg = false;
          }

          //データ処理
          this.dataProcess();
          // console.log(
          //   "this.restockTable = " + JSON.stringify(this.restockTable)
          // );
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0, // DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        10
      );
    },

    //データ処理
    dataProcess() {
      this.restockTable.map((item) => {
        //製品異常区分の変換
        item.odProdExKbn = this.prodExKbnList.find(
          (it) => it.value === item.odProdExKbn
        )?.label;

        //異常製品の提出日の変換
        item.odExCreateDate = formatDateStrToString(item.odExCreateDate);

        // 補足金額
        item.odSupplementAmount = formatStringToCurrency(
          item.odSupplementAmount
        );
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 仕入先納期
        item.odDueDate = formatDateToString(item.odDueDate);
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //支払状態の変換
        // item.aodCloseState = this.exPayMethodList.find(
        //         (it) => it.value === item.odPayStatus
        //       )?.label;

        // //受注クローズ状態の変換
        // item.aodCloseState = this.closeStateList.find(
        //   (it) => it.value === item.aodCloseState
        // )?.label;

        // //クローズ状態の変換
        // item.odCloseState = this.closeStateList.find(
        //   (it) => it.value === item.odCloseState
        // )?.label;
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.restockTable))
        );
        this.numLoads = this.numLoads + 1;
      }
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //異常製品支払方式か「不要」の場合、注文書出力か編集不可
      if (
        column.property === "odOrderNoteOut" &&
        row["odExPayMethod"] == this.exPayMethodList[0].value
      ) {
        return true;
      }

      //「入荷済み数」が0でない場合、クローズか編集不可
      if (column.property === "odCloseState" && row["odReceCompleteQty"] != 0) {
        return true;
      }

      //入荷異常の場合、クローズか編集不可
      if (
        column.property === "odCloseState" &&
        row["odProdExKbn"] == "入荷異常"
      ) {
        return true;
      }

      if (row.odPayStatus !== STR_ONE) {
        return true;
      }
      return false;
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //編集可能な列:
      //「クローズ」「支払区分」「注文書出力」「備考」
      var columnEditable = [
        "odCloseState",
        "odExPayMethod",
        "odOrderNoteOut",
        "odSupplementAmount",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // "odRemarks",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑w
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        "odDueDate",
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      ];

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 品質保証部の権限を追加する
      if (this.isDLUserLocal) {
        columnEditable = columnEditable.filter((item) => item !== "odDueDate");
      }
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      //異常製品支払方式か「不要」の場合、注文書出力か編集不可
      if (
        column.property === "odOrderNoteOut" &&
        row["odExPayMethod"] == this.exPayMethodList[0].value
      ) {
        return;
      }
      //「入荷済み数」が0でない場合、クローズか編集不可
      if (
        column.property === "odCloseState" &&
        (row["odReceCompleteQty"] != 0 || row["odProdExKbn"] == "入荷異常")
      ) {
        return;
      }

      if (
        column.property === "odSupplementAmount" &&
        !this.supplementAmountAbleCheck(row)
      ) {
        return;
      }

      if (
        columnEditable.includes(column.property) &&
        row["odPayStatus"] === "1"
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    // チェックボックスの選択
    handleCheckboxChange(row, column) {
      //true/false ⇒ 0/1
      this.restockTable[row.index][column.property] = row[
        `${column.property}Bool`
      ]
        ? "1"
        : "0";
    },

    //「注文書出力チェックボックス」をクリア
    clearNoteOutCheckBox(row) {
      //必要または赤点⇒不要の場合、注文書出力チェックボックスが選択しないを変更する
      if (
        this.restockTable[row.index]["odExPayMethod"] ==
        this.exPayMethodList[0].value
      ) {
        this.restockTable[row.index]["odOrderNoteOutBool"] = false;
      }
    },

    //注文書出力ボタン
    orderNoteOutputClick() {
      // フォーカス削除
      this.$refs.orderNoteOutputBtn.$el.blur();

      this.outputFlg = true;

      if (this.restockTable.some((item) => item.odOrderNoteOut == 1)) {
        ShowOrderExcelOutputDialog(
          {
            isAdd: true,
            obOrderNo: this.obOrderNo,
            obOrderNoShow: this.obOrderNoShow,
            SupCurrency: this.SupCurrency,
            FactoryKbn: this.FactoryKbn,
          },
          t("resource.ORDER.ORDER_EXCEL_OUTPUT_DIALOG"),

          (target) => {
            if (!!target) {
              //保存
              this.confirmClick(target);
            }
          }
        );
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //確定ボタン--
    confirmClick(data) {
      this.showFlag = true;
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      var tmpTableData = this.restockTable.map((item) => {
        if (
          (item.odProdExKbn == PROD_EX_SEND &&
            item.odCloseStateBool &&
            item.odExPayMethod == NUM_TWO) ||
          (item.odProdExKbn == PROD_EX_JP_RCV && item.odExPayMethod == NUM_TWO)
        ) {
          item.odSupplementAmount = item.odSupplementAmount;
        } else {
          item.odSupplementAmount = 0;
        }

        return {
          ...item,

          //製品異常区分の変換
          odProdExKbn: this.prodExKbnList.find(
            (it) => it.label === item.odProdExKbn
          )?.value,

          // //受注クローズ状態の変換
          // aodCloseState: this.closeStateList.find(
          //   (it) => it.label === item.aodCloseState
          // )?.value,

          //補足金額の変換
          odSupplementAmount: formatCurrencyToNumber(item.odSupplementAmount),
        };
      });

      //更新
      updateRestockInfoByObOrderNo({
        odOrderNo: this.obOrderNo,
        odOrderNoShow: this.obOrderNoShow,
        restockInfoList: tmpTableData,
        loginUser: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
          if (this.outputFlg) {
            this.outputProcess(tmpTableData, data);
          } else {
            this.searchRestockInfoByObOrderNoProc();
          }
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
          this.searchRestockInfoByObOrderNoProc();
        });
    },

    //注文書出力API
    outputProcess(tmpTableData, data) {
      // console.log(data);

      outputExcelToZip(httpApi.OutPutProductCloseSelectDataInOrderExcel, {
        odOrderNo: this.obOrderNo,
        orderBasicDto: data,
        restockInfoList: tmpTableData,
      }).finally(() => {
        this.outputFlg = false;
        this.searchRestockInfoByObOrderNoProc();
      });
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;
      if (index > this.restockTable.length - 1) {
        this.$refs[`input${0}-${columnProp}`][0].focus();
      } else {
        this.$refs[`input${index}-${columnProp}`][0].focus();
      }
    },

    //データの変更
    changeCellData(row, column) {
      this.$nextTick(() => {
        row.odSupplementAmount = formatStringToCurrency(
          formatCurrencyToNumber(row.odSupplementAmount)
        );
      });
    },

    changeCellDataToNumber(row, column) {
      this.$nextTick(() => {
        if (!row.odSupplementAmount) {
          row.odSupplementAmount = 0;
        } else {
          row.odSupplementAmount = formatCurrencyToNumber(
            row.odSupplementAmount
          );
        }
      });
    },

    supplementAmountAbleCheck(row) {
      // 入荷異常品、「クローズ」の場合、支払区分が「補足必要」の場合、補足金額わ入力可能
      if (
        row["odProdExKbn"] == PROD_EX_JP_RCV &&
        row["odExPayMethod"] == NUM_TWO
      ) {
        return true;
      }

      // 納品異常品、「クローズなし」の場合、支払区分が「赤点必要」の場合、補足金額わ入力可能
      if (
        row.odProdExKbn == PROD_EX_SEND &&
        row.odCloseStateBool &&
        row.odExPayMethod == NUM_TWO
      ) {
        return true;
      }

      //その他の場合、補足金額わ入力可能できません
      return false;
    },

    getPayMethodList(row) {
      if (row.odProdExKbn !== PROD_EX_SEND) {
        return this.supplementPayMethodList;
      } else if (row.odCloseStateBool) {
        return this.redPayMethodList;
      } else {
        return this.exPayMethodList;
      }
    },

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          odCloseState: item.odCloseState,
          odExPayMethod: item.odExPayMethod,
          odSupplementAmount: item.odSupplementAmount,
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_備考機能の追加
          // odRemarks: item.odRemarks,
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          odDueDate: item.odDueDate,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        !cmpDetailData(
          this.cmpDetailResult,
          JSON.parse(JSON.stringify(this.extract(this.restockTable)))
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)        //納期コントロール
    dueDateInputProc(row, column) {
      //納期以外の場合、何もしない
      if (column.prop !== "odDueDate") {
        return;
      }
      return true;
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.odQuoteNo,
        row.odProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.restockTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      showRemarksDialog(
        this,
        row.odQuoteNo,
        row.odProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        this.aodUpdateTime
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            this.aodUpdateTime = res.aodUpdateTime;
            this.$set(this.restockTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>

